export class Experience {
  constructor() {
    this.timelineItems = document.querySelectorAll('.timeline-item');
    this.hasAnimated = new Set();
    
    this.init();
  }
  
  init() {
    if (!this.timelineItems.length) return;
    
    this.setupIntersectionObserver();
  }
  
  setupIntersectionObserver() {
    const options = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.hasAnimated.has(entry.target)) {
          this.animateTimelineItem(entry.target);
          this.hasAnimated.add(entry.target);
        }
      });
    }, options);
    
    this.timelineItems.forEach(item => {
      observer.observe(item);
    });
  }
  
  animateTimelineItem(item) {
    // Add animation class
    item.classList.add('animate-in');
    
    // Animate the dot
    const dot = item.querySelector('.timeline-dot');
    if (dot) {
      dot.style.transform = 'scale(1)';
      dot.style.opacity = '1';
    }
    
    // Animate the content
    const content = item.querySelector('.timeline-content');
    if (content) {
      content.style.opacity = '1';
      content.style.transform = 'translateY(0)';
    }
  }
}